module.exports = __webpack_public_path__ + "img/about_join_2.61322e00.png";